import {Breakpoint} from '@/types/Breakpoint';

export interface QueuedInterrupt {
    interrupt: number;
    xtValue: number;
}

export interface Interrupts {
    vector: { [key: number]: number };
    queuedInterrupts: QueuedInterrupt[];
    active: boolean;
    happening: boolean;
    returnAddress: number;
}

export interface Register {
    name: string;
    value: number;
}

export interface SourceLocation {
    filename: string;
    lineNumber: number;
}

export interface Cpu {
    random: number;
    registers: Register[];
    waitingForInterrupt: boolean;
    interrupts: Interrupts;
    currentSourceLocation?: SourceLocation;
    error?: string;
}

export interface Memory {
    data: number[];
    lastUpdated: number[];
    stack: number[];
}

export interface Timer {
    timerFrame: number[];
}

export interface Cursor {
    color: number;
    visible: boolean;
    position: number;
}

export interface LineColor {
    bg: number;
    fg: number;
}

export interface Video {
    palette: string[];
    borderColor: number;
    lineColor: LineColor[];
    cursor: Cursor;
}

export interface Joystick {
    up: boolean;
    down: boolean;
    left: boolean;
    right: boolean;
    z: boolean;
    x: boolean;
    a: boolean;
    s: boolean;
}

export default interface EmulatorInfo {
    cpu: Cpu;
    memory: Memory;
    video: Video;
    timer: Timer;
    joystick: Joystick;
    breakpoints?: Breakpoint[];
    archVersion: string;
}

export function emptyEmulatorInfo() : EmulatorInfo {
    return {
        cpu: {
            random: 0,
            registers: [],
            interrupts: {
                vector: {}, queuedInterrupts: [], active: true, happening: false, returnAddress: 0,
            },
            currentSourceLocation: {
                filename: '',
                lineNumber: -1,
            },
            waitingForInterrupt: false,
        },
        memory: { data: [], lastUpdated: [], stack: [] },
        timer: {
            timerFrame: [],
        },
        video: {
            palette: ['#000000'],
            borderColor: 0,
            lineColor: [],
            cursor: { color: 0, visible: true, position: 0 },
        },
        joystick: {
            up: false,
            down: false,
            left: false,
            right: false,
            a: false,
            s: false,
            x: false,
            z: false,
        },
        breakpoints: [],
        archVersion: '',
    };
}
